/*
 * @Description: 罐车调度
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-06 10:40:10
 */
import request from "@/utils/request";

/**
 * @Description: 获取列表数据
 * @param {*} data
 * @Author: wangwangwang
 */
export function getCarList(data) {
  return request({
    url: "/icps/system/sign/basics/car/queryTanker",
    method: "post",
    data,
  });
}
/**
 * @Description: 罐车调度历史
 * @param {*} data
 * @Author: wangwangwang
 */
export function queryTankerRecord(data) {
  return request({
    url: "/icps/system/sign/basics/car/queryTankerRecord",
    method: "post",
    data,
  });
}
/**
 * @Description: 批量修改罐车状态
 * @param {*} data
 * @Author: wangwangwang
 */
export function batchUpdateStatus(data) {
  return request({
    url: "/icps/system/sign/basics/car/batchUpdateStatus",
    method: "post",
    data,
  });
}
/**
 * @Description: 泵机任务
 * @param {*} data
 * @Author: wangwangwang
 */
export function getTaskList(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/queryPage",
    method: "post",
    data,
  });
}
/**
 * @Description: 根据车辆状态查询车辆列表
 * @param {*} data
 * @Author: wangwangwang
 */
export function queryCarListByStatus(data) {
  return request({
    url: "/icps/system/sign/basics/car/queryCarListByStatus",
    method: "post",
    data,
  });
}
/**
 * @Description: 泵机任务调度
 * @param {*} data
 * @Author: wangwangwang
 */
export function dispatchCar(data) {
  return request({
    url: "/icps/system/sign/basics/dispatch/dispatchCar",
    method: "post",
    data,
  });
}
/**
 * @Description: 通过车牌号查询物流
 * @param {*} data
 * @Author: wangwangwang
 */
export function queryLogisticsByCarNo(data) {
  return request({
    url: "/icps/system/sign/basics/car/queryLogisticsByCarNo",
    method: "post",
    data,
  });
}
/**
 * @Description: 通过车牌号查询物流
 * @param {*} data
 * @Author: wangwangwang
 */
export function handleDispatch(data) {
  return request({
    url: "/icps/system/sign/basics/car/dispatch",
    method: "post",
    data,
  });
}

/**
 * @Description: 取消罐车绑定
 * @param {*} data
 * @Author: wangwangwang
 */
 export function cancelBingding(data) {
  return request({
    url: "/icps/system/sign/intelligent/tankerBinding/cancel",
    method: "post",
    data,
  });
}
